import axios from '../../utils/axios';

const getPaymentLinks = async (page, limit, status, type, clientId) => {
  const response = await axios.get(
    `/api/payment-links?page=${page}&limit=${limit}`
    + `&status=${status}&type=${type}&clientId=${clientId}`,
  );
  return response.data;
};

const getPaymentLinkById = async (id) => {
  const response = await axios.get(`/api/payment-links/${id}`);
  return response.data;
};

const createPaymentLink = async (data) => {
  const response = await axios.post('/api/payment-links', data);
  return response.data;
};

const updatePaymentLink = async (id, data) => {
  const response = await axios.patch(`/api/payment-links/${id}`, data);
  return response.data;
};

const deletePaymentLink = async (id) => {
  const response = await axios.delete(`/api/payment-links/${id}`);
  return response.data;
};

export {
  getPaymentLinks,
  getPaymentLinkById,
  createPaymentLink,
  updatePaymentLink,
  deletePaymentLink,
};
